<template>
  <tilted-background :background-color="backgroundColor">
    <category-explorer
      :categories="categories"
      :show-trial-end-date="false"
      :show-scroll-up="false"
      :show-start-trial="false"
      :clickable-books="false"
      :are-books-linked="false"
      :show-books-from-other-categories="false"
      :centered="false"
      :collapsed-categories-on-mobile="true"
      :background-color="backgroundColor"
      chip-color="bg-white"
      :no-bottom-padding="true"
    >
      <template v-slot:header="headerProps">
        <b-headline type="h2" typography="h2" class="category-explorer__headline text-center text-h35 m:text-h1 mb-8">
          {{ $t("headline") }}
        </b-headline>

        <b-subheadline
          class="category-explorer__subheadline text-center mb-6 m:mb-8"
          v-html="$t('subheadline', { totalCategories: headerProps.totalCategories })"
        />
      </template>

      <template v-slot:category-header="categoryHeaderProps">
        <b-headline
          type="h3"
          typography="h3"
          v-html="$t('categoryHeadline', { categoryName: categoryHeaderProps.title })"
          class="category-book-slider__headline text-h35 m:text-h3 mb-2"
        />

        <b-subheadline class="category-book-slider__subheadline mb-6 m:mb-8">
          {{ $t("categorySubheadline") }}
        </b-subheadline>
      </template>
    </category-explorer>

    <div class="flex justify-center pb-32 p-4">
      <join-button class="z-10" :login-path="loginPath" :signup-path="signupPath" />
    </div>
  </tilted-background>
</template>

<script>
import TiltedBackground from "@/component-library/tilted-background"
import BHeadline from "@/component-library/b-headline"
import CategoryExplorer from "@/component-library/category-explorer"
import BSubheadline from "@/component-library/b-subheadline"
import JoinButton from "./join-button"

export default {
  name: "SpacesCategoryExplorer",
  components: {
    TiltedBackground,
    BHeadline,
    BSubheadline,
    CategoryExplorer,
    JoinButton
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
      required: true
    },
    header: {
      type: String,
      default: ""
    },
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    },
    spaceB2b: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    backgroundColor() {
      return this.spaceB2b ? "bg-pale-mint-grey" : "bg-orchid-violet-7"
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "But, what is Blinkist?",
        subheadline:
          "Listen to the main takeaways from your favorite <span class='font-bold'>non-fiction books and podcasts</span><br/>from {totalCategories} categories, <span class='font-bold'>in only 15min</span>!",
        categoryHeadline: "Most popular in <mark>{categoryName}</mark>",
        categorySubheadline: "Here’s what’s popular with the Blinkist community"
      },
      de: {
        headline: "Moment, was ist Blinkist?",
        subheadline:
          "Bei Blinkist kannst du das Beste aus Sachbüchern und Podcasts lesen und anhören – <span class='font-bold'>in nur 15 Minuten pro Titel</span>!",
        categoryHeadline: "Beliebt in <mark>{categoryName}</mark>",
        categorySubheadline: "Das hört und liest die Blinkist Community"
      }
    }
  }
}
</script>
